import type {
  Plan,
  PlanStarter,
  Program,
} from "@jackedlogs/shared";
import { LibraryBrowser, useCatalogItems, type UiTheme } from "@jackedlogs/ui";

import { apiFetch } from "./api";
import { durableWrite } from "./durableWrite";
import { displayUnitOf, useProfileDoc } from "./useProfileDoc";
import { useWorkoutStarter } from "./useWorkoutStarter";

// Web mount of the shared <LibraryBrowser> — mobile CreateHubLibrary's twin.
// Seams: the web apiFetch and the shared catalog hook. onStarter hands a
// built PlanStarter up to useCreateHubWeb, which routes it to the Workouts
// tab the same way PlanScreen's own "Start" does (RW-18 follow-up). No
// working RN Alert → delete confirms inline (two-tap) on the card. Mounts
// only while the hub is open (Modal unmounts hidden children), so this IS
// the lazy load, same as mobile.
export function CreateHubLibraryWeb({
  theme,
  dark,
  onEditProgram,
  onEditPlan,
  onStarter,
}: {
  theme: UiTheme;
  dark: boolean;
  onEditProgram: (program: Program) => void;
  onEditPlan: (plan: Plan) => void;
  onStarter: (starter: PlanStarter) => void;
}) {
  const catalog = useCatalogItems({ apiFetch });
  // Same read the other console scalars use (cf. MeasurementsScreen): the
  // plan previews show prescribed loads, which are stored in kg.
  const { doc } = useProfileDoc();
  const units = displayUnitOf(doc);
  const bodyweightKg = (doc?.["bodyweightKg"] as number | undefined) ?? null;
  const { starting, startPlan } = useWorkoutStarter(
    catalog.raw ? [...catalog.raw] : null,
    bodyweightKg,
    onStarter,
  );
  return (
    <LibraryBrowser
      theme={theme}
      dark={dark}
      apiFetch={apiFetch}
      durableWrite={durableWrite}
      catalog={catalog.raw ? [...catalog.raw] : null}
      unit={units}
      onEditProgram={onEditProgram}
      onEditPlan={onEditPlan}
      onStartPlan={(plan) => void startPlan(plan)}
      startingPlanId={starting}
    />
  );
}
